import CreateRequest from '@/apps/interviewRequest/new/CreateRequest.vue';

import { requireSeeker } from '../guards/authGuards';
import validateSitterUuid from '../guards/interviewRequestGuards';
import combineGuards from '../guards/helpers';

const interviewRequestRoutes = [
  {
    path: '/interview-request/:sitter_uuid/new',
    name: 'interview-request-new',
    component: CreateRequest,
    beforeEnter: combineGuards([requireSeeker, validateSitterUuid]),
  },
];

export default interviewRequestRoutes;
